/* eslint-disable deprecation/deprecation */
import {
  LabelGroup as DIGLabelGroup,
  LabelGroupProps as DIGLabelGroupProps,
} from '@dropbox/dig-components/combinations';

export const LabelGroup = (props: DIGLabelGroupProps) => <DIGLabelGroup {...props} />;
